import React, { useEffect, useState } from 'react';
import { TitleAndSubTitleBlockProps } from './Types';
import CustomHeader from '../CustomHeader';
import CustomSubTitle from '../CustomSubTitle';

const TitleAndSubTitleBlock = ({
  title,
  subtitle,
  backgroundImage,
  gradientOverlay,
  subTitleStyle,
  titleLevel = 'h2',
  titleTextColor = '#fff',
  titleTextAlignment = 'left',
}: TitleAndSubTitleBlockProps) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);

    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  const isMediumScreen = typeof window !== 'undefined' && window.innerWidth >= 768 && window.innerWidth < 1024;

  const gradientOverlayStyle =
    'linear-gradient(179deg, rgba(0, 85, 128, 0.24) 1.62%, rgba(5, 50, 77, 0.70) 30.28%, rgba(7, 30, 49, 0.75) 99%)';

  const baseStyle = {
    paddingTop: '100px',
    ...(isMobile && { paddingLeft: '26px', paddingTop : '100px' }),
  };

  const divStyle = {
    ...baseStyle,
    ...(backgroundImage && {
      backgroundImage: gradientOverlay
        ? `${gradientOverlayStyle}, url(${backgroundImage})`
        : `url(${backgroundImage})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
    }),
  };

  return (
    <div
      className={`text-left w-full h-full flex flex-col ${!isMobile ? 'justify-center' : 'pt-12'}`}
      style={divStyle}
    >
    <CustomHeader
      text={title}
      data-testid="mock-styled-header"
      headerStyle={{
        level: titleLevel,
        color: titleTextColor,
        alignment: titleTextAlignment,
        fontWeight: 600,
        fontSize: isMobile ? '45px' : isMediumScreen ? '55px' : '64px',
        lineHeight: isMobile ? '44px' : '80px',
        letterSpacing: '0%',
        fontFamily: 'Source Sans 3',
        className: 'benefit-title',
      }}
    />
      <CustomSubTitle
        subtitle={subtitle}
        subTitleStyle={{
          textAlign: subTitleStyle?.alignment || '',
          color: subTitleStyle?.textColor || '#FFF',
          fontFamily: 'Source Sans Pro',
          fontSize: isMobile
            ? '19px'
            : (subTitleStyle &&
                'fontSize' in subTitleStyle &&
                subTitleStyle.fontSize) ||
              '58px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: isMobile
            ? '32px'
            : (subTitleStyle &&
                'lineHeight' in subTitleStyle &&
                subTitleStyle.lineHeight) ||
              '58px',
          marginTop: isMobile? '0.8rem' : '1.5rem',
          marginBottom: isMobile ? '1rem' : undefined,
          ...(subTitleStyle || {}),
        }}
      />
    </div>
  );
};

export default TitleAndSubTitleBlock;
